module.exports = __webpack_public_path__ + "static/media/shop3.6122be3a.jpg";